/**
 * Accedo OVP
 * API version: 1.2.0
 *
 * NOTE: This class was automatically generated by Swagger Code Generator. Do not edit it manually.
 */
'use strict';
var ApiClient = require('../ApiClient');
var TvListingPagedResponse = require('../model/TvListingPagedResponse');
var Error = require('../model/Error');
var TvListing = require('../model/TvListing');
  /**
   * TVListing service.
   * @module api/TVListingApi
   * @version 1.4.0
   */

  /**
   * Constructs a new TVListingApi. 
   * @alias module:api/TVListingApi
   * @class
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function() {

    this.apiClient = new ApiClient();

            

    /**
     * Get TV listing for all channels
     * @param {Number} startTime Starting timestamp (milliseconds) of the requested interval
     * @param {Number} endTime Ending timestamp (milliseconds) of the requested interval
     * @param {Object} opts Optional parameters
     * @param {Number} opts.pageSize The maximum number of objects being returned. Default is 100.
     * @param {Number} opts.pageNumber The page number of the response.. Default is 1.
     * @param {Number} opts.sortBy The sorting order of the response. For example sortBy&#x3D;title|desc.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TvListingPagedResponse}
     */
    this.getTvListing = function(startTime, endTime, opts) {
      opts = opts || {};

      var postBody = null;

      // verify the required parameter 'startTime' is set
      if (startTime == undefined || startTime == null) {
        throw "Missing the required parameter 'startTime' when calling getTvListing";
      }

      // verify the required parameter 'endTime' is set
      if (endTime == undefined || endTime == null) {
        throw "Missing the required parameter 'endTime' when calling getTvListing";
      }


      var pathParams = {
      };
      var queryParams = {
        'startTime': startTime,
        'endTime': endTime,
        'pageSize': opts['pageSize'],
        'pageNumber': opts['pageNumber'],
        'sortBy': opts['sortBy']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TvListingPagedResponse;

      return this.apiClient.call(
        '/tvlisting', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    };


    /**
     * Get TV listing by channel ID
     * @param {String} id 
     * @param {Number} startTime Starting timestamp (milliseconds) of the requested interval
     * @param {Number} endTime Ending timestamp (milliseconds) of the requested interval
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TvListing}
     */
    this.getTvListingByChannelId = function(id, startTime, endTime) {

      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getTvListingByChannelId";
      }

      // verify the required parameter 'startTime' is set
      if (startTime == undefined || startTime == null) {
        throw "Missing the required parameter 'startTime' when calling getTvListingByChannelId";
      }

      // verify the required parameter 'endTime' is set
      if (endTime == undefined || endTime == null) {
        throw "Missing the required parameter 'endTime' when calling getTvListingByChannelId";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'startTime': startTime,
        'endTime': endTime
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TvListing;

      return this.apiClient.call(
        '/tvlisting/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    };
  };

module.exports = exports;
